import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';
import axios from 'axios';

export const postCurrentLocale = async (locale) => {
  const apiURL = API_HOST + '/user/update';
  const { token, userID } = useCurrentUser();
  // console.log('attempting to post current locale: ', locale);
  try {
    const { data } = await axios.put(
      apiURL,
      {
        user: {
          locale: locale,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-dqpn-user-id': userID,
        },
      },
    );
    // console.log('here is the data from postCurrentLocale.js ', data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
